@for (subEntry of subEntries; track subEntry) {
  <!-- subEntry Description -->
  <td attr.data-label="{{ 'cartItems.item' | cxTranslate }}">
    @if (subEntry.product.name) {
      <div class="cx-name">
        {{ subEntry.product.name }}
      </div>
    }
  </td>
  <td class="col-empty"></td>
  <td class="col-empty"></td>
  <td class="col-empty"></td>
  <td class="col-empty"></td>
  <td class="col-empty"></td>
  <!-- subEntry Price -->
  @if (subEntry.customerBasePrice) {
    <td attr.data-label="{{ 'cartItems.itemPrice' | cxTranslate }}" class="align-center">
      @if (subEntry.customerBasePrice) {
        <div class="cx-value">
          {{ subEntry.customerBasePrice?.formattedValue }}
        </div>
      }
    </td>
  }
  <!-- subEntry Total -->
  @if (subEntry.customerTotalPrice) {
    <td attr.data-label="{{ 'cartItems.total' | cxTranslate }}" class="align-center">
      <div class="cx-value">
        {{ subEntry.customerTotalPrice?.formattedValue }}
      </div>
    </td>
  }
  <td class="col-empty"></td>
}
